// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 1,
        "Name": "Prāmis",
        "Descript": "fas fa-ship"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 1,
        "Name": "Ferry",
        "Descript": "fas fa-ship"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 1,
        "Name": "Паром",
        "Descript": "fas fa-ship"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 2,
        "Name": "Parkings",
        "Descript": "fas fa-parking-circle"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 2,
        "Name": "Parking",
        "Descript": "fas fa-parking-circle"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 2,
        "Name": "Стоянка",
        "Descript": "fas fa-parking-circle"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 3,
        "Name": "Degvielas uzpilde",
        "Descript": "fas fa-gas-pump"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 3,
        "Name": "Gas station",
        "Descript": "fas fa-gas-pump"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 3,
        "Name": "Заправочная станция",
        "Descript": "fas fa-gas-pump"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 4,
        "Name": "Viesnīca",
        "Descript": "fad fa-hotel"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 4,
        "Name": "Hotel",
        "Descript": "fad fa-hotel"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 4,
        "Name": "Гостиница",
        "Descript": "fad fa-hotel"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 5,
        "Name": "Vilciens",
        "Descript": "fas fa-train"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 5,
        "Name": "Train",
        "Descript": "fas fa-train"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 5,
        "Name": "Поезд",
        "Descript": "fas fa-train"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 6,
        "Name": "Serviss",
        "Descript": "fa-regular fa-car-wrench"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 6,
        "Name": "Servis",
        "Descript": "fa-regular fa-car-wrench"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 6,
        "Name": "Сервис",
        "Descript": "fa-regular fa-car-wrench"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 7,
        "Name": "Auto mazgātuve",
        "Descript": "fas fa-car-wash"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 7,
        "Name": "Car wash",
        "Descript": "fas fa-car-wash"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 7,
        "Name": "Автомойка",
        "Descript": "fas fa-car-wash"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 8,
        "Name": "Muita",
        "Descript": "fa-regular fa-person-military-pointing"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 8,
        "Name": "Customs office",
        "Descript": "fa-regular fa-person-military-pointing"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 8,
        "Name": "Таможенное управление",
        "Descript": "fa-regular fa-person-military-pointing"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 9,
        "Name": "Elektrības pieslēgums",
        "Descript": "fas fa-bolt"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 9,
        "Name": "Electricity connection",
        "Descript": "fas fa-bolt"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 9,
        "Name": "Подключение электричества",
        "Descript": "fas fa-bolt"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 10,
        "Name": "Uzkraušanas adrese",
        "Descript": "fas fa-truck-loading"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 10,
        "Name": "Loading place",
        "Descript": "fas fa-truck-loading"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 10,
        "Name": "Место загрузки",
        "Descript": "fas fa-truck-loading"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 11,
        "Name": "Piegādes adrese",
        "Descript": "fas fa-truck-loading fa-flip-horizontal"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 11,
        "Name": "Delivery place",
        "Descript": "fas fa-truck-loading fa-flip-horizontal"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 11,
        "Name": "Место выгрузки",
        "Descript": "fas fa-truck-loading fa-flip-horizontal"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 12,
        "Name": "Reisa sākums",
        "Descript": ""
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 12,
        "Name": "Start of trip",
        "Descript": ""
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 12,
        "Name": "Начало поездки",
        "Descript": ""
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 13,
        "Name": "Reisa beigas",
        "Descript": ""
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 13,
        "Name": "End of trip",
        "Descript": ""
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 13,
        "Name": "Конец поездки",
        "Descript": ""
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 14,
        "Name": "Paņemt piekabi",
        "Descript": "fa-solid fa-trailer"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 14,
        "Name": "Pick up trailer",
        "Descript": "fa-solid fa-trailer"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 14,
        "Name": "Поставить прицеп",
        "Descript": "fa-solid fa-trailer"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 15,
        "Name": "Nolikt piekabi",
        "Descript": "fa-solid fa-trailer fa-flip-horizontal"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 15,
        "Name": "Drop trailer",
        "Descript": "fa-solid fa-trailer fa-flip-horizontal"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 15,
        "Name": "Поставьте прицеп",
        "Descript": "fa-solid fa-trailer fa-flip-horizontal"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 16,
        "Name": "Šofera maiņa",
        "Descript": "fa-solid fa-id-card"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 16,
        "Name": "Changing driver",
        "Descript": "fa-solid fa-id-card"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 16,
        "Name": "Смена водителя",
        "Descript": "fa-solid fa-id-card"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 17,
        "Name": "Dokumentu maiņa",
        "Descript": "fas fa-file-exclamation"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 17,
        "Name": "Change of documents",
        "Descript": "fas fa-file-exclamation"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 17,
        "Name": "Изменение документов",
        "Descript": "fas fa-file-exclamation"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 18,
        "Name": "Tunelis",
        "Descript": "fas fa-archway"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 18,
        "Name": "Tunnel",
        "Descript": "fas fa-archway"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 18,
        "Name": "Туннель",
        "Descript": "fas fa-archway"
    },
    {
        "Type": 306,
        "LanguageId": 1,
        "Id": 19,
        "Name": "Tilts",
        "Descript": "fa-solid fa-bridge"
    },
    {
        "Type": 306,
        "LanguageId": 2,
        "Id": 19,
        "Name": "Bridge",
        "Descript": "fa-solid fa-bridge"
    },
    {
        "Type": 306,
        "LanguageId": 4,
        "Id": 19,
        "Name": "Мост",
        "Descript": "fa-solid fa-bridge"
    },
    {
        "Type": 359,
        "LanguageId": 1,
        "Id": 1,
        "Name": "IEKRAUŠANA",
        "Descript": ""
    },
    {
        "Type": 359,
        "LanguageId": 2,
        "Id": 1,
        "Name": "LOADING",
        "Descript": ""
    },
    {
        "Type": 359,
        "LanguageId": 4,
        "Id": 1,
        "Name": "ЗАГРУЗКА",
        "Descript": ""
    },
    {
        "Type": 359,
        "LanguageId": 1,
        "Id": 2,
        "Name": "PIEGĀDE",
        "Descript": ""
    },
    {
        "Type": 359,
        "LanguageId": 2,
        "Id": 2,
        "Name": "DELIVERY",
        "Descript": ""
    },
    {
        "Type": 359,
        "LanguageId": 4,
        "Id": 2,
        "Name": "ДОСТАВКА",
        "Descript": ""
    },
    {
        "Type": 359,
        "LanguageId": 1,
        "Id": 3,
        "Name": "EXTRA STOP",
        "Descript": ""
    },
    {
        "Type": 359,
        "LanguageId": 2,
        "Id": 3,
        "Name": "EXTRA STOP",
        "Descript": ""
    },
    {
        "Type": 359,
        "LanguageId": 4,
        "Id": 3,
        "Name": "EXTRA STOP",
        "Descript": ""
    }
];